<div class="statistics-container">
    <div class="statistics-header">
        <div class="header-left">
            <span class="stats-title">Summary Statistics</span>
            <span
                class="period-info"
                *ngIf="periodStart && periodEnd"
            >
                {{ periodStart | date: 'dd/MM/yyyy' }} -
                {{ periodEnd | date: 'dd/MM/yyyy' }}
                <span
                    *ngIf="showUserFilter && userUuid"
                    class="user-filter"
                    >| User: {{ userUuid }}</span
                >
            </span>
        </div>
    </div>

    <div
        class="stats-chips"
        *ngFor="let element of statisticsData"
    >
        <div class="stat-chip">
            <span class="chip-label">Tickets</span>
            <span class="chip-value">{{ element.num | number }}</span>
        </div>

        <div class="stat-chip">
            <span class="chip-label">Payin</span>
            <span class="chip-value">{{
                element.payin | number: '1.2-2'
            }}</span>
        </div>

        <div class="stat-chip">
            <span class="chip-label">Payout</span>
            <span class="chip-value">{{
                element.payout | number: '1.2-2'
            }}</span>
        </div>

        <div
            class="stat-chip"
            [ngClass]="{
                negative: element.revenue < 0,
                positive: element.revenue > 0
            }"
        >
            <span class="chip-label">Revenue</span>
            <span class="chip-value">{{
                element.revenue | number: '1.2-2'
            }}</span>
        </div>

        <div
            class="stat-chip"
            [ngClass]="{
                negative: element.profit < 0,
                positive: element.profit > 0
            }"
        >
            <span class="chip-label">Margin</span>
            <span class="chip-value"
                >{{ element.profit | number: '1.2-2' }}%</span
            >
        </div>
    </div>
</div>
